import { render, staticRenderFns } from "./NbContactsCard.vue?vue&type=template&id=cf8478d0&scoped=true&"
import script from "./NbContactsCard.vue?vue&type=script&lang=js&"
export * from "./NbContactsCard.vue?vue&type=script&lang=js&"
import style0 from "./NbContactsCard.vue?vue&type=style&index=0&id=cf8478d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8478d0",
  null
  
)

export default component.exports